// Deliberately limited to sources supported by the qualification handoff.
const allowedLeadSources = ['AR_SIGN_UP'] as const

export type AllowedLeadSource = (typeof allowedLeadSources)[number]

const allowedLeadSourceSet: ReadonlySet<string> = new Set(allowedLeadSources)

export function isAllowedLeadSource(value: unknown): value is AllowedLeadSource {
  return typeof value === 'string' && allowedLeadSourceSet.has(value)
}
